import { formatDate } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable, of, Subscription } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AppConstatnts } from 'src/app/common/constants/app-contstants';
import { EditorMode, VippsPaymentStatus } from 'src/app/common/enums/enums';
import { DateHelper } from 'src/app/common/helpers/date-helper';
import { GuidGenerator } from 'src/app/common/helpers/guid-generator';
import { TranslateHandler } from 'src/app/common/helpers/translate-handler';
import { BackupFile } from 'src/app/common/models/BackupFile';
import { EditorReferenceInfo } from 'src/app/common/models/editors/editor-reference-info';
import { CelebrationsModel } from 'src/app/common/models/event/celebrationsModel';
import { FamilyProjectDetailsModel } from 'src/app/common/models/familyproject/FamilyProjectDetailsModel';
import { ResponseModel } from 'src/app/common/models/ResponseModel';
import { RootMember } from 'src/app/common/models/RootMember';
import { UserModel } from 'src/app/common/models/UserModel';
import { MessageDialogService } from "src/app/components/common/message-dialog/services/message-dialog.service";
import { BackupApiService } from 'src/app/services/API/backup-api.service';
import { EventApiService } from 'src/app/services/API/event-api.service';
import { FamilyProjectApiService } from 'src/app/services/API/family-project-api.service';
import { MembershipApiService } from 'src/app/services/API/membership-api.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { MembershipService } from 'src/app/services/membership.service';
import { NotificationService } from 'src/app/services/Notification.service';
import { NotifierV2Service } from 'src/app/services/notifier-v2.service';
import { ProjectRefService } from 'src/app/services/project-ref.service';
import { DialogService } from 'src/app/services/UI/dialog.service';
import { LoadingService } from 'src/app/services/UI/loading.service';
import { UploadStateService } from 'src/app/services/upload-state.service';
import { UserUpdateService } from 'src/app/services/user-update.service';
import { environment } from 'src/environments/environment';
import { NotifierEvents } from '../../../common/enums/enums';
import { GenealogyDate } from 'src/app/common/helpers/date/genealogy-date';
import { PreferencesService } from 'src/app/services/preferences.service';
import { GenealogyDateMode } from 'src/app/common/enums/enums';
import { GenealogyDateValidator } from 'src/app/common/helpers/date/genealogy-date-validator';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
    standalone: false
})
export class DashboardComponent implements OnInit {
  
  user : UserModel;
  celebrations: CelebrationsModel[];
  familyProjectDetails: FamilyProjectDetailsModel;
  private lastProjectId: string;
  processId: string;
  private sub: Subscription;
  paymentStatus:VippsPaymentStatus;
  private purchasedProducts: any[] = [];
  programs: any[] = [];
  allPrograms: any[] = [];
  customerId: string;
  youtubeUrl: SafeResourceUrl;
  isExpireMessageVisible: boolean = false;

  selectedFile: File | null = null;
  isDragOver = false;
  selectedFileName: string | null = null;
  hasValidationError = false;
  isUploading = false;
  uploadProgress = 0;
  hasUploadError = false;
  hasDeleteError = false;
  backupFiles: BackupFile[] = [];
  private uploadSub: Subscription | null = null;

  // Footer
  currentYear: number = new Date().getFullYear();
  dashboard = environment.DASHBOARD;
  knowledgebaseUrl = environment.FT_HELP_URL;
  privacyPolicyUrl: string;

  // Toggle this to simulate server error
  simulateError = true;

  // Backup table 
  allSelected = false;
  selectedCount = 0;
  @ViewChild('headerCheckbox') headerCheckbox?: ElementRef<HTMLInputElement>;

  constructor(
    readonly projectRefService : ProjectRefService,
    readonly authenticationService : AuthenticationService,
    readonly translateHandler : TranslateHandler,
    readonly notifierService : NotifierV2Service,
    readonly dialogService : DialogService,
    readonly familyProjectService : FamilyProjectApiService,
    readonly translateService : TranslateService,
    readonly eventApiService : EventApiService,
    readonly router : Router,
    private notificationService: NotificationService,
    private membershipApiService: MembershipApiService,
    protected messageDialogService      : MessageDialogService,
    private http: HttpClient,
    private membershipService: MembershipService,
    private sanitizer: DomSanitizer,
    private backupService: BackupApiService,
    private uploadState: UploadStateService,
    private dateHelper: DateHelper,
    private userUpdateService: UserUpdateService,
    private preferenceService : PreferencesService,
    private loadingService: LoadingService)
   {
    this.setVideoUrl();
  }

  familySummaryTableData = [
    { translationKey: 'lbl_people', property: 'people' },
    { translationKey: 'lbl_families', property: 'families' },
    { translationKey: 'lbl_multimedia', property: 'multimedias' },
    { translationKey: 'lbl_places', property: 'places' },
    { translationKey: 'lbl_sources', property: 'sources' },
    { translationKey: 'lbl_events', property: 'events' }
  ];

  whatsNewNotes = [
    { 
      description: 'dashboard.lbl_whats_new.note_13.description',
      date: 'dashboard.lbl_whats_new.note_13.date',
      version: 'dashboard.lbl_whats_new.note_13.version'
    },
    { 
      description: 'dashboard.lbl_whats_new.note_12.description',
      date: 'dashboard.lbl_whats_new.note_12.date',
      version: 'dashboard.lbl_whats_new.note_12.version'
    },
    { 
      description: 'dashboard.lbl_whats_new.note_11.description',
      date: 'dashboard.lbl_whats_new.note_11.date',
      version: 'dashboard.lbl_whats_new.note_11.version'
    },
    { 
      description: 'dashboard.lbl_whats_new.note_10.description',
      date: 'dashboard.lbl_whats_new.note_10.date',
      version: 'dashboard.lbl_whats_new.note_10.version'
    }
  ];

  ngOnInit(): void {
    window.addEventListener('beforeunload', this.beforeUnloadHandler.bind(this));
    this.uploadState.uploading$.subscribe(state => {
      this.isUploading = state;
    });

    this.user = this.authenticationService.getUser();
    this.getUser();
    this.userUpdateService.userName$.subscribe(name => {
      if (name) {
        this.getUser();
      }
    });
    this.lastProjectId = this.projectRefService.getCurrentProject()?.familyProjectId;
    this.purchasedProducts = this.user?.purchasedProducts ?? [];
    this.customerId = this.user?.CustomerId;
    this.getProjectDetails();
    this.getCelebrations();
    this.loadSetupPrograms();
    this.setKnowledgebaseUrl();
    this.loadBackups();
    
    const ongoingUploads = Object.keys(this.backupService['uploadTasks']);
    if (ongoingUploads.length > 0) {
      const fileName = ongoingUploads[0]; 
      const task = this.backupService['uploadTasks'][fileName];

      // Restore selected file state
      this.selectedFile = task.file;
      this.selectedFileName = fileName;
      this.uploadState.setUploading(true);

      // Subscribe to progress
      task.progressSubject.subscribe({
        next: progress => this.uploadProgress = progress,
        error: () => {
          this.hasUploadError = true;
          this.uploadState.setUploading(false);
        },
        complete: () => {
          this.uploadState.setUploading(false);
          this.selectedFile = null;
          this.selectedFileName = '';
        }
      });
    }
    // Subscribe to SignalR updates
    this.sub = this.notificationService.paymentStatus$
      .subscribe(update => {
        this.paymentStatus = update.status;
      });

       this.onPaymentCompleted();

  }

  onPrivacyPolicyClick(event: Event){
    event.preventDefault(); // prevent default anchor navigation
    this.privacyPolicyUrl = environment.DASHBOARD.PRIVACY_POLICY_URL_NO;
    const returnTo = encodeURIComponent(window.location.origin + '/dashboard');
    window.location.href = this.privacyPolicyUrl + '?returnTo=' + returnTo;
  }

  get isEnglish(): boolean {
    return this.translateService.currentLang === 'en';
  }

  setKnowledgebaseUrl(){
    const currentLang = this.translateService.currentLang;
    this.knowledgebaseUrl = environment.FT_HELP_URL+"?lang="+currentLang;
  }

  ngDoCheck(): void {
    let currentProjectId = this.projectRefService.getCurrentProject()?.familyProjectId;
    if (currentProjectId && currentProjectId !== this.lastProjectId) {
      this.lastProjectId = currentProjectId;
      this.getProjectDetails();
      this.getCelebrations();
    }
  }

  ngAfterViewInit(): void {
    this.updateHeaderCheckboxState();
  }

  getToday(format :string){
    return formatDate(Date.now(), format, this.isEnglish ? 'en-US' : 'nb');
  }

  getProjectCount(){
    return this.projectRefService.getProjectList().length;
  }
  getCurrentProjectName(){
    return this.projectRefService.getCurrentProject()?.projectName;
  }

  getUsername(){    
    return this.user.FirstName;
  }
  
  getUser() {
    const cached = this.authenticationService.getCookieUserName();
    if (cached && Object.keys(cached).length > 0) {
      this.user.FirstName = cached.firstName;
      return;
    }
  }

  getWelcomeMessage(){    
    if ( this.user.IsFirstTime ){
      return this.translateHandler.translate("dashboard.lbl_welcome", [this.user.FirstName]);
    }else{
      return this.translateHandler.translate("dashboard.lbl_welcome_back", [this.user.FirstName])
    }
  }

  getMembershipValidateTime(){
    const expireDate = this.membershipService.getExpireDate();

    if (!expireDate) {
      return this.translateHandler.translate('dashboard.lbl_membership_no_expiry');
    }

    const dateObj = new Date(expireDate);
    if (isNaN(dateObj.getTime())) {
      return '';
    }

    const culture = this.preferenceService.getCulture() || 'no';

    const year = dateObj.getFullYear();
    const month = dateObj.getMonth() + 1; // 1-based
    const day = dateObj.getDate();

    // Construct GenealogyDate (will fail validation because it's future)
    const genealogyDate = new GenealogyDate(
      `${day}/${month}/${year}`,
      culture,
      year.toString(),
      month.toString(),
      day.toString(),
      GenealogyDateMode.full
    );

    genealogyDate.year = year;
    genealogyDate.month = month;
    genealogyDate.day = day;
    genealogyDate.isValidDate = true;

    const formattedDate = this.dateHelper.formatDate(genealogyDate);

    return this.translateHandler.translate('dashboard.lbl_member_till',[formattedDate]);
  }

  onPaymentCompleted() {
    this.membershipService.refreshExpireDateWithDelays();
  }
  
  onExpireStateChange(expireVisible: boolean) {
    this.isExpireMessageVisible = expireVisible;
  }
  
  openTreeEditor(){
    let ref:EditorReferenceInfo = {
      id : this.notifierService.getCurrentRootMemberId(),      
      isBreadcrumbUpdate: true
    }
    this.notifierService.openEditor(EditorMode.TreeEditor, ref);
  }

  openCreateImportPanel(mode: any) {
    let popupInput = {
      viewMode: mode,
      showMode: [mode],
      selectedProjectId: null,
      FamilyProjectList: this.projectRefService.getProjectList(),
    }
    this.dialogService.setFull().open("AddNewProjectMain", popupInput).subscribe(response => {
      if (response?.data != null) { //data = null when the user cancel the popup without any change
        this.projectRefService.load().then(() => {
          if (response?.data == "success" || response?.data == "import_success") { // New tree or Import success
            this.openTreeEditor()
          }
        })
      }
    });
  }

  getMessageState() {

    if (this.projectRefService.getProjectList().length == 0) return 0;

    // Project editable = valid and not importing
    if (this.projectRefService.getCurrentProject()?.isValid && !this.projectRefService.getCurrentProject()?.isImporting) return 1;

    if (this.projectRefService.getCurrentProject()?.isImporting) return 2;

    if (!this.projectRefService.getCurrentProject()?.isValid) return 3;

  }

  getProjectDetails() {
    this.familyProjectDetails = new FamilyProjectDetailsModel();
    let familyProjectId = this.projectRefService.getCurrentProject()?.familyProjectId;
    this.familyProjectService.getFamilyProjectStats(familyProjectId).subscribe(res => {
      Object.assign(this.familyProjectDetails, res.data);
      this.familyProjectDetails.treeSize = this.familyProjectDetails.getSize();
    })
  }

  getCelebrations() {
    this.celebrations = new Array<CelebrationsModel>();
    this.eventApiService.getMonthlyCelebrations().subscribe(
      (response:ResponseModel<CelebrationsModel[]>) => {
        this.celebrations = response.data;
      },
      (error) => console.error('Error fetching celebrations : ', error)
    );
  }

  openGreetingReport(celebrationType: string, individual: any) {
    var rootMember = <RootMember>{ Id: individual.id + "", DisplayName: individual.givenName + " " + individual.surname, Gender: ' ' };
    this.notifierService.updateEvent(NotifierEvents.RootMemberChanged, rootMember).then(() => {
      this.router.navigate([AppConstatnts.routerModes[celebrationType]]);
    })
  }
  
  getEnvironment(){
    return environment;
  }
  setVideoUrl() {    
    this.youtubeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.getEnvironment().DASHBOARD.YOUTUBE_VIDEO_URL);
  }
  openTab(url:string){    
    window.open(url, "_blank");
  }
  getFtHelpRoute(route:string){
    return `${route}?lang=${this.translateService.currentLang}`
  }

  showError(title: string, info: string, prompt: string): Observable<any> {
    return this.messageDialogService.openError(
      this.translateHandler.translate(title),
      this.translateHandler.translate(info),
      prompt == null ? null : this.translateHandler.translate(prompt)
    );
  }

  checkFileExists(filePath: string): Observable<boolean> {
  return this.http.get(filePath, { responseType: 'text' }).pipe(
    map(() => true), // file loaded
    catchError(() => of(false)) // 404 or error
  );}

  onProgramDownload(program: any): void {
    this.membershipApiService.getDownloadUrl(program.downloadFileName).subscribe(url => {
      window.open(url, "_self");  
    });
  }

  hasPurchasedV10Only(): boolean {
    if (typeof this.purchasedProducts === 'string') {
      this.purchasedProducts = [this.purchasedProducts];
    }

    // If user purchased ONLY v10 
    return (
      this.purchasedProducts.length === 1 &&
      this.purchasedProducts.includes('OEMBLAV10')
    );
  }

  /** Build the programs list based on purchased versions */
  loadSetupPrograms() {
    // Display version mapping for each product
    const displayVersionMap: Record<string, string> = {
      OEMBLAV8: "8.0.20",
      OEMBLAV9: "9.0.410"
    };

    this.allPrograms = [
      { name: 'dashboard.lbl_your_programs.download_version_08', version: "OEMBLAV8", downloadFileName:'Oppstart_embla80200web.exe' }, 
      { name: "dashboard.lbl_your_programs.download_version_09", version: "OEMBLAV9", downloadFileName:'Oppstart_embla90410web.exe' },
    ];

    // Filter only purchased versions
    this.programs = this.allPrograms
      .filter(p => this.purchasedProducts.includes(p.version))
      .map(p => ({
        ...p,
        displayVersion: displayVersionMap[p.version],
        licenseKeys: ''
      }));

    // Load license keys asynchronously per program
    this.programs.forEach(program => {

      this.membershipApiService
        .getLicenseSerials(this.customerId, program.version)
        .subscribe(serials => {
          program.licenseKeys = serials;
        });
    });
  }

      // called on header checkbox change
  onToggleAll(event: Event): void {
    const checked = (event.target as HTMLInputElement).checked;
    this.backupFiles.forEach(f => (f.selected = checked));
    this.updateHeaderCheckboxState();
  }

  // called on row checkbox change
  onToggleRow(file: BackupFile, event: Event): void {
    file.selected = (event.target as HTMLInputElement).checked;
    this.updateHeaderCheckboxState();
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
    this.isDragOver = true;
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    this.isDragOver = false;
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;

    this.resetState();

    if (!input.files || !input.files.length) return;

    const file = input.files[0];
    this.selectedFile = file;
    this.selectedFileName = file.name;

    // validate only if .zip
    if (!file.name.toLowerCase().endsWith('.zip')) {
      this.hasValidationError = true;
    }

     input.value = '';
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    this.resetState();

    if (!event.dataTransfer?.files.length) return;

    const file = event.dataTransfer.files[0];
    this.selectedFile = file;
    this.selectedFileName = file.name;

    if (!file.name.toLowerCase().endsWith('.zip')) {
      this.hasValidationError = true;
    }
  }

  onUpload(): void {
    if (!this.selectedFile || this.hasValidationError) return;

    const fileName = this.selectedFile.name;
    const fileNameRegex = /^Restore_.+_\d{8}\.zip$/;

    if (!fileNameRegex.test(fileName)) {
      this.hasValidationError = true;
      this.hasUploadError = false;
      return;
    } else {
      this.hasValidationError = false;
    }

    this.backupService.checkFileExists(fileName).subscribe(exists => {
      if (exists) {
        this.messageDialogService.openExistingNameConfirmation(this.translateHandler.translate("dashboard.lbl_backup.upload_confirmation"),true)
          .subscribe((confirmed: boolean) => {
            if (confirmed) {
              this.startUpload();
            } else {
              this.uploadProgress = 0;
            }
          });
      } else {
        this.startUpload();
      }
    });
  }

  private startUpload(): void {
    this.uploadState.setUploading(true);
    this.uploadProgress = 0;
    this.hasUploadError = false;

    const progress$ = this.backupService.uploadFile(this.selectedFile);

    this.uploadSub = progress$.subscribe({
      next: (progress: number) => this.uploadProgress = progress,
      error: (err) => {
        this.hasUploadError = true;
        this.uploadState.setUploading(false);
      },
      complete: () => {
        this.uploadProgress = 100;
        this.selectedFile = null;
        this.selectedFileName = '';
        this.uploadState.setUploading(false);
        this.uploadSub = null;

        this.messageDialogService.openInfoSingleBtn(
          this.translateHandler.translate("dashboard.lbl_backup.upload_success_title"),
          this.translateHandler.translate("dashboard.lbl_backup.upload_success_info"),"",true
        );

        setTimeout(() => {
          this.projectRefService.load();
        }, 5000);
        this.loadBackups();
      }
    });
  }

  onClearFile(): void {
    if (this.selectedFile && this.isUploading) {
      this.backupService.cancelUpload(this.selectedFile.name); 
      if (this.uploadSub) {
        this.uploadSub.unsubscribe();
        this.uploadSub = null;
      }
    }
    this.resetState();
  }

  private resetState(): void {
    this.selectedFile = null;
    this.selectedFileName = '';
    this.hasValidationError = false;
    this.hasUploadError = false;
    this.hasDeleteError = false;
    this.isUploading = false;
    this.uploadProgress = 0;
  }

  loadBackups(): void {
    this.backupService.getAllBackups().subscribe({
      next: (data) => {
        const culture = this.preferenceService.getCulture() || 'no';
        const validator = new GenealogyDateValidator(culture);

        this.backupFiles = data.map(file => {
          let formattedDate = '';

          // Try GenealogyDate parsing FIRST (handles "29. des 2025")
          const result = validator.validateDate(file.backupDate);

          if (result instanceof GenealogyDate) {
            formattedDate = this.dateHelper.formatDate(result);
          }
          else {
            // Fallback: try JS Date (ISO / DateTime cases)
            const jsDate = new Date(file.backupDate);

            if (!isNaN(jsDate.getTime())) {
              const fallbackResult = validator.validateDate(
                `${jsDate.getDate()}/${jsDate.getMonth() + 1}/${jsDate.getFullYear()}`
              );

              if (fallbackResult instanceof GenealogyDate) {
                formattedDate = this.dateHelper.formatDate(fallbackResult);
              }
            }
          }

          return {
            ...file,
            backupDate: formattedDate || file.backupDate // safe fallback
          };
        });
      },
      error: (err) => console.error('Error fetching backups', err)
    });
  }

  private updateHeaderCheckboxState(): void {
    const total = this.backupFiles.length;
    const selected = this.backupFiles.filter(f => f.selected).length;

    this.allSelected = total > 0 && selected === total;

    if (this.headerCheckbox?.nativeElement) {
      const el = this.headerCheckbox.nativeElement;
      el.indeterminate = selected > 0 && selected < total;
    }

    this.selectedCount = this.backupFiles.filter(f => f.selected).length;
  }

  onDelete(file: BackupFile): void {
    this.messageDialogService.openDeleteConfirmation(file.backupName).subscribe((dialogRes: boolean) => {
      if (dialogRes) {
        this.backupService.deleteBackup([file.backupName]).subscribe({
          next: (success) => {
            if (success) {
              this.hasDeleteError = false;
              this.loadBackups();
              this.allSelected = false;
              if (this.headerCheckbox?.nativeElement) {
                this.headerCheckbox.nativeElement.indeterminate = false;
              }
              this.selectedCount = 0;
            } else {
              this.hasDeleteError = true;
              this.showError(
                "lbl_error_heading",
                "dashboard.lbl_backup.error.delete_error",
                "dashboard.lbl_backup.error.delete_error"
              )
              setTimeout(() => {
                this.hasDeleteError = false;
              }, 60000);
            }
          },
          error: (err) => {
            this.showError(
              "lbl_error_heading",
              "dashboard.lbl_backup.error.delete_error",
              null
            )
            setTimeout(() => {
              this.hasDeleteError = false;
            }, 60000);
          }
        });
      }
    })
  }

  onDeleteSelected(): void {
    const selectedFiles = this.backupFiles.filter(f => f.selected);
    if (!selectedFiles.length) return;

    const fileNames = selectedFiles.map(f => f.backupName);
    const message = this.translateHandler.translate("dashboard.lbl_backup.you_have_selected") + " : " + fileNames.length + " " + this.translateHandler.translate("dashboard.lbl_backup.backup")
    this.messageDialogService.openDeleteConfirmation(message).subscribe((dialogRes: boolean) => {
      if (dialogRes) {
        this.backupService.deleteBackup(fileNames).subscribe({
          next: (success) => {
            if (success) {
              this.hasDeleteError = false;
              this.loadBackups();
              this.allSelected = false;
              if (this.headerCheckbox?.nativeElement) {
                this.headerCheckbox.nativeElement.indeterminate = false;
              }
              this.selectedCount = 0;
            } else {
              this.hasDeleteError = true;
              setTimeout(() => {
                this.hasDeleteError = false;
              }, 60000);
            }
          },
          error: (err) => {
            this.hasDeleteError = true;
            setTimeout(() => {
              this.hasDeleteError = false;
            }, 60000);
          }
        });
      }
    })
  }

  onBackupDownload(file: BackupFile): void {
    this.messageDialogService
      .openExistingNameConfirmation(
        this.translateHandler.translate("dashboard.lbl_backup.download_confirmation"),true 
      )
      .subscribe((confirmed: boolean) => {

        if (!confirmed) {
          return;
        }

        const processId = GuidGenerator.generate();
        this.loadingService.show(processId);

        this.backupService.downloadBackup(file.backupName).subscribe({
          next: (blob) => {
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = file.backupName;
            a.click();
            window.URL.revokeObjectURL(url);

            this.loadingService.hide(processId);
          },
          error: () => {
            this.loadingService.hide(processId);
          }
        });
      });
  }

  ngOnDestroy(): void {
    window.removeEventListener('beforeunload', this.beforeUnloadHandler.bind(this));
  }

  private beforeUnloadHandler(event: BeforeUnloadEvent) {
    if (this.isUploading) {
      event.preventDefault();
      event.returnValue = '';
    }
  }

}
